import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
import Icon from '@material-ui/core/Icon';
import Button from '@material-ui/core/Button';
import React, { useEffect, useMemo } from 'react';
import { withTranslation, WithTranslation } from 'react-i18next';
import { connect } from 'react-redux';
// Components
import App from '../../components/app';
import { AutoFill } from '../../components/field-autofill';
import EnhancedForm from '../../components/form';
import ErrorMessage from '../../components/error-message';
import FormInput from '../../components/form/formInput';
import { Dialog } from '../../components/dialog';
import MainLoading from '../../components/main-loading';
import ReserverForbiddenView from './reserver-forbidden';
// Modules
import {
    AccountType,
    AvailableDispatchGroup,
    BookingById,
    BookingCancelPayload,
    BookingStatus,
    DispatchGroup,
    EtaWithGroups,
    POI,
    POIStatus,
    PriceConfirmationById,
    RiderFavorites,
    RiderReserver,
} from '../../redux/reducers/api-types';
import { ErrorPayload, selectors as errorSelectors, actions as errorActions } from '../../redux/reducers/errors';
import { actions as reservationActions } from '../../redux/reducers/reservations';
import { actions as riderActions, selectors as riderSelectors } from '../../redux/reducers/riders';
import { actions as driverActions, selectors as driverSelectors } from '../../redux/reducers/drivers';
import { actions as bookingActions, selectors as bookingSelectors } from '../../redux/reducers/bookings';
import { selectors as pendingSelectors } from '../../redux/reducers/pendingOperations';
// Ressources
import withGlobalStyles from '../../utils/global-styles';
import FormattingUtils from '../../utils/formattingUtils';
import ObjectUtils from '../../utils/objectUtils';
import FormUtils from '../../utils/forms';
import DateUtils from '../../utils/dateUtils';
import AddressUtils from '../../utils/addressUtils';
import FormSubmit from '../../components/form/formSubmit';
import StringUtils from '../../utils/stringUtils';
import { generateFormOptions, generateMadOptions } from '../../utils/businessUtils';
import { getGeoAutocompleteURL, getListCompaniesMembershipURL, getListRidersURL } from '../../utils/core-api';
import { clsx } from '../../utils/htmlUtils';
import { FormatType, FormDatas, FormPickerDatas } from '../../local-types';

interface ReserverAddProps extends WithTranslation {
    history?: any;
    globalClasses: any;
    bookings: BookingById;
    poi: POI;
    poiStatus: POIStatus;
    etaWithGroups: EtaWithGroups;
    favorites: RiderFavorites;
    dispatchGroups: DispatchGroup[];
    availableGroups: AvailableDispatchGroup[];
    priceConfirmation: PriceConfirmationById;
    foundRider: RiderReserver;
    isLoadingOrders: boolean;
    saveReservationError: ErrorPayload;
    getBookingOrCancelError: ErrorPayload;
    getCreatePriceConfirmationError: ErrorPayload;
    getConfirmPriceConfirmationError: ErrorPayload;
    createReservation: (payload: any, callBack: (payload) => void) => void;
    getBooking: (id: string) => void;
    cancelBooking: (id: string, payload: BookingCancelPayload) => void;
    clearPickUp: () => void;
    clearReserver: () => void;
    clearPriceConfirmation: () => void;
    createPriceConfirmation: (payload: any) => void;
    confirmPriceConfirmation: (id: string, payload: any, callBack: (payload) => void) => void;
    getAvailableGroups: (payload: { lat: number; lng: number; profile: string; rider: number; date?: number }) => void;
    getEtaWithGroups: (payload: { lat: number; lng: number }) => void;
    getPoi: (payload: { lat: number; lng: number }) => void;
    checkFlight: (poiID, carrierCodeAndFlightNumber, time) => void;
    clearFlight: () => void;
    getRiderFavorite: (id) => void;
    getDispatchGroups: () => any;
    clearAllErrors: () => void;
}

const REFRESH_TIME = 10000;

export enum RIDE_TYPE {
    normal = 'normal',
    free = 'free',
    mad = 'mad',
}

const ReserverAddPage = (props: ReserverAddProps): JSX.Element => {
    const classes = useStyles();

    const {
        t,
        globalClasses,
        dispatchGroups,
        bookings,
        foundRider,
        favorites,
        poi,
        poiStatus,
        etaWithGroups,
        availableGroups,
        priceConfirmation,
        saveReservationError,
        getBookingOrCancelError,
        getCreatePriceConfirmationError,
        getConfirmPriceConfirmationError,
        isLoadingOrders,
        clearPriceConfirmation,
        createPriceConfirmation,
    } = props;

    // const foundRider: RiderReserver = {
    //     id: 88907,
    //     type: '',
    //     banned: {
    //         value: false,
    //         description: '',
    //     },
    //     firstname: 'test',
    //     lastname: 'test',
    //     phone_number: '+33 6 00 00 00 00',
    //     email: 'clad58@yopmail.com',
    //     isModeCB: false,
    //     company: {
    //         id: 77,
    //         name: 'Test 17',
    //         book_for_others: true,
    //         cost_center_mandatory: true,
    //         ride_reason_mandatory: true,
    //         cost_centers: [
    //             { id: 45, name: '^^', description: '^^', active: true },
    //             { id: 3, name: 'Centre 10e', description: 'J\u0027adore mon m\u00e9tier', active: true },
    //             { id: 1, name: 'Centre hoho premier', description: 'Description ?', active: true },
    //             { id: 7, name: 'Test aaa', description: 'Jamais 10 sans 11', active: true },
    //         ],
    //         default_cost_center: {
    //             id: 3,
    //             name: 'Centre 10e',
    //             description: 'J\u0027adore mon m\u00e9tier',
    //             active: true,
    //         },
    //         dispatch_group_authorizations: [
    //             { id: 'fastnfurious', dispatch_group: 'XiG7GWQD6$2cdEXmZTqDyw', status: false, status_bo: false },
    //             { id: 'green', dispatch_group: 'vff8Vli88frWI7t4B4QyoA', status: true, status_bo: true },
    //             { id: 'moto', dispatch_group: 'HXRaZ:pV4CsRLj9u$nr18Q', status: true, status_bo: true },
    //             { id: 'normal', dispatch_group: 'dLjpx26LLzSIXesmK$fhXg', status: true, status_bo: true },
    //             { id: 'sncfpap', dispatch_group: 'Jt1eDfWIjDUvTEBN2w6d3w', status: true, status_bo: true },
    //             { id: 'van', dispatch_group: 'XknywKSReUY2kMtzjNuU0Q', status: true, status_bo: true },
    //         ],
    //     },
    // };

    // const bookingOK = {
    //     id: 23033,
    //     uuid: '4c9106f0-d54f-41f3-98b0-63a296ca8e44',
    //     rider: { id: 2114224, firstname: 'Jean', lastname: 'Dupong', phone_number: '+33600000000' },
    //     booker: { id: 88907, firstname: 'test', lastname: 'test', phone_number: '+33600000000' },
    //     nameboard: false,
    //     server_time: 1605804352,
    //     timezone: 'Europe/Paris',
    //     start_location: {
    //         id: 719244,
    //         address: { city: '\u00cele-de-France', name: 'Beauchamp, Val-d\u0027Oise', country: 'France' },
    //         position: { lat: 49.00922, lng: 2.19806 },
    //         control_tower: 1,
    //     },
    //     profile: AccountType.PRO,
    //     driver_additional_info: 'J\u0027aime les chips',
    //     reference: '23ZERE21',
    //     status: 'created',
    //     creation_date: 1605804349,
    //     planned_end_location: {
    //         id: 719245,
    //         address: { name: 'Paris', country: 'France' },
    //         position: { lat: 48.85718, lng: 2.34141 },
    //     },
    //     dispatch_group: {
    //         id: 'normal',
    //         type: 'normal',
    //         name: 'Berline',
    //         vehicle_types: [
    //             { id: 'sedan', name: 'Berline', type: 'sedan' },
    //             { id: 'van', name: 'Van', type: 'van' },
    //         ],
    //         default_vehicle_type: { id: 'sedan', name: 'Berline', type: 'sedan' },
    //         reservable: 1,
    //     },
    //     fixed_rate: false,
    //     onboard_payment: 0,
    // };

    const [formData, setFormData] = React.useState<any>({
        is_pro: foundRider?.company ? true : false,
        is_passenger: true,
        is_asap: false,
        // driver_additional_info: "J'aime les chips",
        // reference: '23ZERE21',
        rider: [`(${foundRider.id}) ${StringUtils.userFullname(foundRider)}`],
        rider_id: foundRider.id,
        book_for_others: foundRider?.company?.book_for_others,
        cost_center: '' + (foundRider?.company?.default_cost_center?.id || foundRider?.company?.cost_centers?.[0]?.id),
    });
    const [response, setResponse] = React.useState<any>(null);
    const [timer, setTimer] = React.useState<NodeJS.Timeout>(null);
    const [timerPrice, setTimerPrice] = React.useState<NodeJS.Timeout>(null);
    const [payload, setPayload] = React.useState<any>(null);
    const [formPoi, setFormPoi] = React.useState<any>({ number: null });

    const dgaKeys = useMemo(() => {
        return foundRider.company?.dispatch_group_authorizations.filter((o) => o.status).map((o) => o.id);
    }, [foundRider.company?.dispatch_group_authorizations]);

    const dialogRef = React.useRef(null);

    useEffect(() => {
        props.getRiderFavorite(foundRider.id);

        if (dispatchGroups.length === 0) {
            props.getDispatchGroups();
        }

        return () => {
            props.clearReserver();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        return () => {
            if (timer) {
                // console.log('timer', timer);
                clearInterval(timer);
            }
        };
    }, [timer]);

    useEffect(() => {
        return () => {
            if (timerPrice) {
                // console.log('timerPrice', timerPrice);
                clearInterval(timerPrice);
            }
        };
    }, [timerPrice]);

    useEffect(() => {
        if (timerPrice) {
            clearInterval(timerPrice);
        }
        const keys = Object.keys(priceConfirmation);
        if (payload && priceConfirmation && keys.length > 0) {
            const nextTick = priceConfirmation[keys[0]].expiry_date * 1000 - new Date().getTime();
            // console.log(nextTick, payload, generatePriceConfirmationPayload());
            if (nextTick > 0) {
                setTimerPrice(
                    setInterval(() => {
                        clearPriceConfirmation();
                        const dataPayload = generatePriceConfirmationPayload();
                        if (dataPayload) {
                            createPriceConfirmation(dataPayload);
                        }
                    }, nextTick),
                );
            }
        }

        return () => {
            if (timerPrice) {
                clearInterval(timerPrice);
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [priceConfirmation, createPriceConfirmation, clearPriceConfirmation]);

    const launchInterval = (payload) => {
        if (timer) {
            clearInterval(timer);
        }
        if (payload.profile) {
            setTimer(setInterval(() => props.getBooking(payload.id), REFRESH_TIME));
        }
    };

    //==========================================//
    //=============== Generators ===============//
    //==========================================//

    const getEtaFromClosest = (id) => {
        const res = etaWithGroups?.data?.[id]?.closest?.eta;
        return res ? `(${Math.ceil(res / 60)} min)` : '';
    };

    const getPrice = (id) => {
        const promo =
            priceConfirmation[id]?.formatted_total_price !== priceConfirmation[id]?.formatted_price
                ? priceConfirmation[id]?.formatted_price
                : null;
        const res = `${priceConfirmation[id]?.formatted_total_price}${
            promo ? ' => ' + promo + ' ' + t('reservation:promo') : ''
        }`;
        return priceConfirmation[id]?.formatted_total_price ? res : '';
    };

    const generateDispatchOptions = (): FormPickerDatas[] => {
        let optionsDispatch: FormPickerDatas[] = dispatchGroups.map((dg) => {
            return {
                id: dg.id,
                name: `${dg.name} ${getEtaFromClosest(dg.id)} ${getPrice(dg.id)}`,
            };
        });

        if (
            foundRider?.company?.dispatch_group_authorizations &&
            foundRider.company?.dispatch_group_authorizations.length > 0
        ) {
            optionsDispatch = optionsDispatch.filter((o) => dgaKeys.includes(o.id));
        }

        if (availableGroups?.length > 0) {
            const keys = availableGroups.map((g) => g.id);
            optionsDispatch = optionsDispatch.filter((o) => keys.includes(o.id));
        }

        if (priceConfirmation && Object.keys(priceConfirmation).length > 0) {
            const keys = Object.keys(priceConfirmation);
            optionsDispatch = optionsDispatch.filter((o) => keys.includes(o.id));
        }

        return optionsDispatch;
    };

    const generatePassengerOptions = (): FormPickerDatas[] => {
        const optionsDispatch: FormPickerDatas[] = [
            { id: 'me', name: t('form.me', { fullname: `${StringUtils.userFullname(foundRider)}` }) },
            { id: 'company', name: t('form.company') },
            { id: 'guest', name: t('form.guest') },
        ];
        return optionsDispatch;
    };

    const generateRideOptions = (): FormPickerDatas[] => {
        const optionsRide: FormPickerDatas[] = [
            { id: RIDE_TYPE.normal, name: t('form.ride.normal') },
            { id: RIDE_TYPE.free, name: t('form.ride.free') },
            { id: RIDE_TYPE.mad, name: t('form.ride.mad') },
        ];
        return optionsRide;
    };

    const generateCostCenters = (): FormPickerDatas[] => {
        let costCenters: FormPickerDatas[] = [];
        if (foundRider?.company?.cost_centers) {
            costCenters = generateFormOptions(
                foundRider.company.cost_centers.filter((cc) => cc.active),
                'id',
            );
        }
        return costCenters;
    };

    const generatePOIPicker = (): FormPickerDatas[] => {
        let options: FormPickerDatas[] = [];
        if (poi?.POI) {
            options = poi.POI.map(({ id, name, rdv_point }) => ({
                id: '' + id,
                name: `${name} (${rdv_point})`,
            }));
            // Remove all the other possibilities except the one of the POI.id
            // if (poiStatus?.POI?.id) {
            // options = options.filter((o) => o.id === '' + poiStatus.POI.id);
            // }
        }
        return options;
    };

    const generateInputs = (): FormDatas[] => {
        let timeToDestination = -1;
        let dateServer = new Date();
        let dateToDestination = new Date();
        // Compute time to destination
        const keysPC = Object.keys(priceConfirmation);
        if (priceConfirmation && keysPC.length > 0 && !payload?.is_asap) {
            dateServer = new Date(
                !payload?.is_asap && payload?.start_date
                    ? payload.start_date
                    : priceConfirmation[keysPC[0]].server_timestamp * 1000,
            );
            timeToDestination = Object.values(priceConfirmation)
                .map((p) => p.time)
                .reduce((a, b) => Math.max(a, b));
            dateToDestination = new Date(dateServer.getTime() + timeToDestination * 1000);
        }

        const inputs: FormDatas[] = [
            {
                title: t('reservation:recurrents.infos.title'),
                datas: [
                    {
                        id: 'is_pro',
                        label: t('common:form.perso'),
                        type: 'switch',
                        disable: !foundRider?.company,
                        switchOnLabel: t('common:form.pro'),
                        hint: t('form.pro_hint'),
                    },
                    {
                        id: 'is_passenger_perso',
                        label: t('form.passenger'),
                        linked: formData.book_for_others ? [{ id: 'is_pro', value: false }] : [],
                        disable: true,
                        defaultValue: t('form.me', { fullname: StringUtils.userFullname(foundRider) }),
                    },
                    {
                        id: 'is_passenger',
                        label: t('form.passenger'),
                        linked: [
                            { id: 'is_pro', value: true },
                            { id: 'book_for_others', value: true },
                        ],
                        type: 'picker',
                        noEmpty: true,
                        options: generatePassengerOptions(),
                    },
                    {
                        id: 'rider',
                        label: t('reservation:rider'),
                        linked: [
                            { id: 'is_pro', value: true },
                            { id: 'is_passenger', value: 'company' },
                        ],
                        customView: (val, handleChange) => {
                            const companyId = foundRider?.company?.id;
                            let api = getListRidersURL();
                            let customDatalist = null;
                            let onFind = null;
                            if (companyId) {
                                api = getListCompaniesMembershipURL(companyId);
                                customDatalist = (obj) => {
                                    const select = obj.rider;
                                    const value = `(${select.id}) ${select.fullname || select.name}${
                                        select.banned ? ` - ${t('common:banned')}` : ''
                                    }`;
                                    return (
                                        <option
                                            key={select.id}
                                            value={value}
                                            data-id={select.id}
                                            disabled={select.banned}
                                        >
                                            {value}
                                        </option>
                                    );
                                };
                                onFind = (datas, id) => {
                                    return datas.find((x) => x.rider && x.rider.id === id)?.rider;
                                };
                            }
                            return (
                                <AutoFill
                                    formControl={false}
                                    datas={{
                                        id: 'rider',
                                        name: 'rider[0]',
                                        label: t('reservation:rider'),
                                        minChar: 1,
                                        style: {
                                            marginLeft: 16,
                                            minWidth: 200,
                                            width: '100%',
                                            flex: 1,
                                            marginRight: 8,
                                            paddingRight: 32,
                                        },
                                        variant: 'outlined',
                                        onChange: (idc, text, item, list, event) => {
                                            // setState({ idc, text });
                                            handleChange(event);
                                        },
                                        onFind: onFind,
                                        loaderPosition: 'right',
                                        api: api,
                                        customDatalist: customDatalist,
                                    }}
                                />
                            );
                        },
                    },
                    // Guest fields
                    {
                        id: 'guest[lastname]',
                        label: t('common:form.lastname'),
                        linked: [
                            { id: 'is_pro', value: true },
                            { id: 'is_passenger', value: 'guest' },
                        ],
                        required: true,
                    },
                    {
                        id: 'guest[firstname]',
                        label: t('common:form.firstname'),
                        linked: [
                            { id: 'is_pro', value: true },
                            { id: 'is_passenger', value: 'guest' },
                        ],
                        required: true,
                    },
                    {
                        id: 'guest[phone]',
                        label: t('common:form.phone_number'),
                        type: 'tel',
                        linked: [
                            { id: 'is_pro', value: true },
                            { id: 'is_passenger', value: 'guest' },
                        ],
                        required: true,
                    },
                    {
                        id: 'guest[email]',
                        label: t('common:form.email'),
                        linked: [
                            { id: 'is_pro', value: true },
                            { id: 'is_passenger', value: 'guest' },
                        ],
                    },
                    {
                        id: 'ride_type',
                        label: t('form.ride.title'),
                        type: 'picker',
                        noEmpty: true,
                        options: generateRideOptions(),
                    },
                    {
                        id: 'pu',
                        label: t('reservation:pu'),
                        customView: (val, handleChange) => {
                            return (
                                <AutoFill
                                    datas={{
                                        id: 'pu',
                                        label: t('reservation:recurrents.infos.address_pu'),
                                        style: {
                                            minWidth: 200,
                                            width: '100%',
                                            flex: 1,
                                            marginRight: 8,
                                            paddingRight: 32,
                                        },
                                        variant: 'outlined',
                                        location: true,
                                        minChar: 3,
                                        onChange: handleChange,
                                        favorites: favorites,
                                        api: getGeoAutocompleteURL(),
                                    }}
                                />
                            );
                        },
                    },
                    {
                        id: 'do',
                        label: t('reservation:do'),
                        linked: [{ id: 'ride_type', value: [RIDE_TYPE.normal, RIDE_TYPE.mad] }],
                        customView: (val, handleChange) => {
                            return (
                                <AutoFill
                                    datas={{
                                        id: 'do',
                                        label: t('reservation:recurrents.infos.address_do'),
                                        style: {
                                            minWidth: 200,
                                            width: '100%',
                                            flex: 1,
                                            marginRight: 8,
                                            paddingRight: 32,
                                        },
                                        variant: 'outlined',
                                        location: true,
                                        minChar: 3,
                                        required: false,
                                        onChange: handleChange,
                                        favorites: favorites,
                                        api: getGeoAutocompleteURL(),
                                    }}
                                />
                            );
                        },
                    },
                    {
                        id: 'dispatch_group',
                        label: t('reservation:recurrents.infos.vehicule_type_info'),
                        required: true,
                        options: generateDispatchOptions(),
                        noEmpty: true,
                    },
                    {
                        id: 'is_asap',
                        label: t('form.asap'),
                        linked: [{ id: 'ride_type', value: [RIDE_TYPE.normal, RIDE_TYPE.free] }],
                        type: 'boolean',
                    },
                    {
                        id: 'start_date',
                        label: t('common:date'),
                        required: true,
                        linked: [
                            { id: 'is_asap', value: false },
                            { id: 'ride_type', value: [RIDE_TYPE.normal, RIDE_TYPE.free] },
                        ],
                        onBlurOnly: true,
                        type: 'datetime-local',
                        hint:
                            timeToDestination > 0
                                ? t('arrival_time', {
                                      date: DateUtils.dateFormat(dateToDestination.getTime(), 'dd/mm/yyyy HH:MM'),
                                      time: DateUtils.getFullDiff(
                                          t,
                                          DateUtils.dateDiff(dateServer, dateToDestination, { sec: true }),
                                      ),
                                  })
                                : timeToDestination === 0
                                  ? t('no_arrival_time')
                                  : null,
                    },
                    {
                        id: 'start_date',
                        label: t('common:date'),
                        required: true,
                        linked: [{ id: 'ride_type', value: [RIDE_TYPE.mad] }],
                        onBlurOnly: true,
                        type: 'datetime-local',
                    },
                    {
                        id: 'provision',
                        label: t('form.mad_time'),
                        type: 'picker',
                        noEmpty: true,
                        required: true,
                        linked: [{ id: 'ride_type', value: RIDE_TYPE.mad }],
                        options: generateMadOptions(),
                    },
                ],
            },
            {
                title: t('reservation:recurrents.infos.options'),
                datas: [
                    // {
                    //     id: 'nameboard_option',
                    //     label: t('reservation:nameboard_option'),
                    //     type: 'boolean',
                    // },
                    { id: 'driver_additional_info', label: t('reservation:driver_additional_info') },
                    {
                        id: 'cost_center',
                        label: t('form.cost_center'),
                        options: generateCostCenters(),
                        required: foundRider?.company?.cost_center_mandatory,
                        linked: { id: 'is_pro', value: true },
                    },
                    {
                        id: 'reason',
                        label: t('form.ref'),
                        required: foundRider?.company?.ride_reason_mandatory,
                        linked: { id: 'is_pro', value: true },
                    },
                ],
            },
        ];

        if (!ObjectUtils.isEmpty(poi)) {
            let type, placeholder;
            switch (poi.mode) {
                case 'airport':
                    type = 'flight_number';
                    placeholder = 'AA000';
                    break;
                case 'station':
                    type = 'train_number';
                    placeholder = '34923';
                    break;
                default:
                    type = 'normal';
                    placeholder = '';
            }

            inputs.push({
                title: poi.name,
                datas: [
                    {
                        id: type,
                        label: t(`reservation:${type}`),
                        customView: () => {
                            if (type === 'normal') {
                                return null;
                            }
                            return (
                                <div style={{ display: 'flex', flexDirection: 'column', marginBottom: 16 }}>
                                    <div
                                        style={{
                                            display: 'flex',
                                            flexDirection: 'row',
                                            flex: 1,
                                        }}
                                    >
                                        <FormInput
                                            id={type}
                                            name={type}
                                            type={'text'}
                                            placeholder={placeholder}
                                            value={formPoi[type]}
                                            label={t(`reservation:${type}`)}
                                            inputProps={{
                                                form: 'form_poi',
                                            }}
                                            required={true}
                                            disabled={false}
                                            handleChange={handleChangePoi}
                                        />
                                        {poi.mode === 'airport' && (
                                            <Button
                                                type="submit"
                                                variant="contained"
                                                form="form_poi"
                                                style={{
                                                    height: 56,
                                                    alignSelf: 'flex-end',
                                                    marginBottom: 10,
                                                }}
                                                color={'secondary'}
                                            >
                                                <Icon fontSize="small">send</Icon>
                                            </Button>
                                        )}
                                    </div>
                                    {poiStatus && poiStatus.timezone && renderFlightDetail()}
                                </div>
                            );
                        },
                    },
                    {
                        id: 'poi_id',
                        label: poi.menuname,
                        options: generatePOIPicker(),
                        hint: t('reservation:poi_hint'),
                    },
                ],
            });
        }

        return inputs;
    };

    const handleChangePoi = (event) => {
        setFormPoi(FormUtils.nextSubState(event, formPoi));
    };

    const handlePOINumberSubmit = (e) => {
        e.preventDefault();

        props.clearFlight();
        if (formPoi && formPoi.flight_number) {
            const startDate =
                payload && !payload.is_asap && payload.start_date
                    ? Math.trunc(new Date(payload.start_date).getTime() / 1000)
                    : Math.trunc(new Date().getTime() / 1000);
            props.checkFlight(poi.id, formPoi.flight_number, startDate);
        }
    };

    //=======================================//
    //=============== Actions ===============//
    //=======================================//

    const generatePriceConfirmationPayload = (datas = null) => {
        const newFormData = datas ? datas : payload;

        const asap = newFormData && newFormData.ride_type === RIDE_TYPE.mad ? false : newFormData.is_asap;

        if (
            newFormData &&
            ((!asap && !newFormData.start_date) ||
                !newFormData.pu ||
                (!newFormData.do && newFormData.ride_type === RIDE_TYPE.normal) ||
                newFormData.ride_type === RIDE_TYPE.free)
        ) {
            return null;
        }

        const startDate =
            newFormData && !asap && newFormData.start_date
                ? Math.trunc(new Date(newFormData.start_date).getTime() / 1000)
                : undefined;

        const pricePayload: any = {
            booker: foundRider.id,
            start_location: AddressUtils.extractLoc(newFormData.pu),
            end_location: AddressUtils.extractLoc(newFormData.do),
            date: startDate,
            start_date: startDate,
            later: !asap,
            nameboard: 0,
            profile: newFormData.is_pro ? AccountType.PRO : AccountType.PERSO,
        };

        if (newFormData.ride_type === RIDE_TYPE.mad && newFormData.provision) {
            pricePayload.provision = { duration: parseInt(newFormData.provision) };
            if (!pricePayload.end_location) {
                delete pricePayload.end_location;
            }
        }

        if (newFormData.is_passenger === 'me') {
            pricePayload.rider = newFormData.rider_id;
        } else if (
            newFormData.is_passenger === 'company' &&
            newFormData.rider[0] &&
            newFormData.rider[0].match(/\((\d*?)\).*/)
        ) {
            const [, rider_id] = newFormData.rider[0].match(/\((\d*?)\).*/);
            pricePayload.rider = +rider_id;
        } // Guest on envoi rien

        /* 
        // Decomment to send the poi_id and trip_connection 
        if (!ObjectUtils.isEmpty(poi) && AddressUtils.isSameLocation(payload?.pu, newFormData?.pu)) {
            if (newFormData.poi_id) {
                pricePayload.poi_id = newFormData.poi_id;
            }
            if (poi?.POI?.length === 1) {
                pricePayload.poi_id = poi.POI[0].id;
            }
            if (poiStatus?.POI?.id) {
                pricePayload.poi_id = poiStatus.POI.id;
            }

            if (poiStatus?.id && formPoi.flight_number) {
                pricePayload.trip_connection = { id: poiStatus.id };
            }
            if (formPoi.train_number) {
                pricePayload.trip_connection = { train_number: formPoi.train_number };
            }
        }
        */

        return pricePayload;
    };

    const getAvailableGroups = (location, datas) => {
        const asap = datas && datas.ride_type === RIDE_TYPE.mad ? false : datas.is_asap;

        const startDate =
            datas && !asap && datas.start_date ? Math.trunc(new Date(datas.start_date).getTime() / 1000) : undefined;

        const availablePayload: any = {
            lat: location.lat,
            lng: location.lng,
            profile: datas.is_pro ? AccountType.PRO : AccountType.PERSO,
            rider: foundRider.id,
        };
        if (startDate) {
            availablePayload.date = startDate;
        }
        props.getAvailableGroups(availablePayload);
    };

    const onChange = (newFormData) => {
        const locationPickupChanged = !AddressUtils.isSameLocation(payload?.pu, newFormData?.pu);

        if (!ObjectUtils.isEmpty(poi) && payload?.pu && locationPickupChanged) {
            props.clearPickUp();
        }
        if (
            newFormData.pu &&
            (!payload || !payload.pu || payload.pu.place_id !== newFormData.pu.place_id || locationPickupChanged)
        ) {
            const location = AddressUtils.extractLoc(newFormData.pu);
            props.clearPickUp();
            props.getEtaWithGroups(location);
            props.getPoi(location);
            getAvailableGroups(location, newFormData);
        }

        if ((payload?.pu && !newFormData.pu) || (payload?.do && !newFormData.do)) {
            props.clearPriceConfirmation();
            clearInterval(timerPrice);
        }

        if (
            newFormData.pu &&
            payload &&
            (payload.start_date !== newFormData.start_date ||
                payload.is_pro !== newFormData.is_pro ||
                payload.is_asap !== newFormData.is_asap)
        ) {
            const location = AddressUtils.extractLoc(newFormData.pu);
            getAvailableGroups(location, newFormData);
        }

        if (
            newFormData.pu &&
            payload &&
            payload.start_date !== newFormData.start_date &&
            formPoi?.flight_number &&
            poi?.id
        ) {
            if (newFormData.start_date) {
                props.clearFlight();
                const startDate = Math.trunc(new Date(newFormData.start_date).getTime() / 1000);
                props.checkFlight(poi.id, formPoi.flight_number, startDate);
            }
        }

        let rider_id_changed = false;
        if (newFormData.rider?.[0] && newFormData.rider[0].match(/\((\d*?)\).*/)) {
            const [, rider_id] = newFormData.rider[0].match(/\((\d*?)\).*/);
            rider_id_changed = foundRider.id !== +rider_id;
        }

        if (
            ((newFormData.ride_type === RIDE_TYPE.normal || newFormData.ride_type === RIDE_TYPE.free) &&
                newFormData.pu &&
                newFormData.do &&
                (!payload.pu ||
                    !payload.do ||
                    payload.ride_type !== newFormData.ride_type ||
                    payload.pu.place_id !== newFormData.pu.place_id ||
                    locationPickupChanged ||
                    payload.do.place_id !== newFormData.do.place_id ||
                    !AddressUtils.isSameLocation(payload.do, newFormData.do) ||
                    payload.start_date !== newFormData.start_date ||
                    payload.is_pro !== newFormData.is_pro ||
                    payload.is_asap !== newFormData.is_asap ||
                    rider_id_changed)) ||
            (newFormData.ride_type === RIDE_TYPE.mad &&
                newFormData.provision &&
                newFormData.pu &&
                newFormData.start_date &&
                (!payload.pu ||
                    !payload.provision ||
                    payload.ride_type !== newFormData.ride_type ||
                    payload.provision !== newFormData.provision ||
                    payload.pu.place_id !== newFormData.pu.place_id ||
                    locationPickupChanged ||
                    payload.do?.place_id !== newFormData.do?.place_id ||
                    !AddressUtils.isSameLocation(payload.do, newFormData.do) ||
                    payload.start_date !== newFormData.start_date ||
                    payload.is_pro !== newFormData.is_pro ||
                    rider_id_changed))
        ) {
            props.clearPriceConfirmation();
            const dataPayload = generatePriceConfirmationPayload(newFormData);
            if (dataPayload) {
                props.createPriceConfirmation(dataPayload);
            }
        }

        setPayload(newFormData);
    };

    const onSubmitReservation = (formData: any, event: any) => {
        props.clearAllErrors();
        setFormData(formData);
        formData.booker_id = foundRider.id;
        if (formData.rider[0] && formData.rider[0].match(/\((\d*?)\).*/)) {
            const [, rider_id] = formData.rider[0].match(/\((\d*?)\).*/);
            formData.rider_id = rider_id;
        }

        if (!formData.is_pro) {
            delete formData.cost_center;
            delete formData.guest;
            formData.is_passenger = 'me';
        }

        if (formData.ride_type === RIDE_TYPE.mad) {
            delete formData.is_asap;
        }

        if (formData.ride_type !== RIDE_TYPE.mad) {
            delete formData.provision;
        }

        if (formData.ride_type === RIDE_TYPE.free) {
            delete formData.do;
        }

        if (formData.is_asap) {
            delete formData.start_date;
        }

        if (formData.cost_center === 'undefined' || formData.cost_center === '') {
            delete formData.cost_center;
        }
        if (formData.is_passenger === 'me') {
            formData.rider = [`(${foundRider.id}) ${StringUtils.userFullname(foundRider)}`];
            formData.rider_id = foundRider.id;
        } else if (formData.is_passenger === 'guest') {
            formData.is_guest = true;
        }

        if (!ObjectUtils.isEmpty(poi)) {
            if (poiStatus?.id && formPoi.flight_number) {
                formData.trip_connection = { id: poiStatus.id };
            }
            if (formPoi.train_number) {
                formData.trip_connection = { train_number: formPoi.train_number };
            }

            // Fallbacks
            if (poi?.POI?.length === 1) {
                formData.poi_id = poi.POI[0].id;
            }
            // from check flight
            // if (poiStatus?.POI?.id) {
            //     formData.poi_id = poiStatus.POI.id;
            // }
        } else {
            delete formData.poi_id;
            delete formData.trip_connection;
        }

        formData.dispatch_group = event.target.dispatch_group.value;

        if (priceConfirmation && Object.keys(priceConfirmation).length > 0) {
            let pc = priceConfirmation[formData.dispatch_group];
            if (!pc) {
                if (generateDispatchOptions()[0]) {
                    pc = priceConfirmation[generateDispatchOptions()[0].id];
                } else {
                    alert('No dispatch group available...');
                    return;
                }
            }
            props.confirmPriceConfirmation(pc?.id, formData, handleResponse);
        } else {
            // console.log('Course libre', formData);
            props.createReservation(formData, handleResponse);
        }
    };

    const handleResponse = (response) => {
        setResponse(response);
        if (response.type === 'booking') {
            console.log('New asap done', response);
            launchInterval(response);
        } else {
            console.log('New reservation done', response);
        }
        if (dialogRef?.current) {
            dialogRef.current.showDialog();
        }
    };

    //=======================================//
    //=============== Renders ===============//
    //=======================================//

    const renderFlightDetail = () => {
        let labelColor = 'red';
        let flightDetail = t('reservation:flight.not_found');
        if (poiStatus.carrier_name) {
            const arrivalDate = DateUtils.tsToDate(poiStatus.planned_arrival_date, false);
            if (
                payload?.start_date &&
                poiStatus.planned_arrival_date * 1000 > new Date(payload.start_date)?.getTime()
            ) {
                flightDetail = `${t('reservation:flight.too_early')} (${arrivalDate})`;
            } else {
                labelColor = 'inherit';
                flightDetail = t('reservation:flight.found', {
                    carrier_name: poiStatus.carrier_name,
                    flight_number_and_carrier_name: poiStatus.flight_number_and_carrier_name,
                    terminal: poiStatus.arrival_terminal,
                    arrival_date: arrivalDate,
                });
            }
        }

        return (
            <div
                style={{
                    margin: '8px 16px',
                    color: labelColor,
                }}
            >
                {flightDetail}
            </div>
        );
    };

    const renderReservationDialog = () => {
        return (
            <Dialog
                description={
                    t('reservation.done') + FormattingUtils.format(response?.start_date, FormatType.DateLong, t)
                }
                onRef={(ref) => (dialogRef.current = ref)}
                disableEscapeManual={true}
                onOK={() => {
                    clearInterval(timerPrice);
                    props.history.goBack();
                }}
                noKOButton={true}
            />
        );
    };

    const renderBookingDialog = () => {
        const booking = bookings[response.id];
        // console.log('booking', booking);
        let description = booking?.status_description || response?.status_description || t('booking.searching');
        let component = (
            <div className={classes.center}>
                <MainLoading />
            </div>
        );
        let noKOButton = false;
        let noOKButton = true;
        let goBack = true;
        if (booking) {
            if (booking.status === BookingStatus.CREATED) {
            } else if (booking.status === BookingStatus.CANCELLED) {
                if (booking.cancellation_reason === 'converted_to_reservation') {
                    description = booking.status_popup?.title || t('booking.cancelled');
                    component = <p>{booking.status_popup?.message || t(`booking:${booking.cancellation_reason}`)}</p>;
                    goBack = true;
                    clearInterval(timerPrice);
                } else {
                    description = t('booking.cancelled');
                    component = <p>{t(`booking:${booking.cancellation_reason}`)}</p>;
                    goBack = false;
                }
                clearInterval(timer);
                noKOButton = true;
                noOKButton = false;
            } else {
                description = t('booking.accepted');
                const time = booking?.latest_distance?.time ?? booking?.initial_distance?.time;
                component = <p>{t('booking.found', { minutes: Math.ceil((time ?? 0) / 60) })}</p>;
                clearInterval(timerPrice);
                clearInterval(timer);
                noKOButton = true;
                noOKButton = false;
            }
        }

        return (
            <Dialog
                description={description}
                onRef={(ref) => (dialogRef.current = ref)}
                disableEscapeManual={true}
                formComponent={component}
                btnOKText={t('common:ok')}
                onOK={() => {
                    if (goBack) {
                        clearInterval(timerPrice);
                        props.history.goBack();
                    }
                }}
                btnKOText={t('booking.cancel')}
                onKO={() => {
                    clearInterval(timer);
                    props.cancelBooking(response.id, { description: 'Call Center - Manual Cancel' });
                }}
                noKOButton={noKOButton}
                noOKButton={noOKButton}
            />
        );
    };

    const renderDialog = () => {
        return formData?.is_asap && response ? renderBookingDialog() : renderReservationDialog();
    };

    const renderRiderInfos = () => {
        return (
            <div className={clsx(globalClasses.block, classes.flex)}>
                <p className={globalClasses.details}>
                    {t('user', {
                        fullname: StringUtils.userFullname(foundRider),
                    })}
                    {foundRider.isModeCB && t('user_cb', { cb: foundRider.cb })}
                </p>
            </div>
        );
    };

    return (
        <App
            noFav
            header={{
                title: t('description'),
            }}
        >
            {foundRider?.id ? (
                <>
                    {renderRiderInfos()}
                    <ErrorMessage payload={getBookingOrCancelError} />
                    <ErrorMessage payload={saveReservationError} />
                    <ErrorMessage payload={getConfirmPriceConfirmationError} />
                    <ErrorMessage payload={getCreatePriceConfirmationError} />
                    <FormSubmit debounceSubmit={{ callback: handlePOINumberSubmit }} id="form_poi">
                        <input type="submit" hidden value="Ok" />
                    </FormSubmit>
                    <EnhancedForm
                        payload={formData}
                        inputs={generateInputs()}
                        loader={isLoadingOrders}
                        onChange={onChange}
                        onSubmit={onSubmitReservation}
                        disableEnterSubmit={true}
                        submitDisabled={
                            payload?.start_date &&
                            poiStatus.planned_arrival_date * 1000 > new Date(payload.start_date)?.getTime()
                        }
                    />
                </>
            ) : (
                <ReserverForbiddenView />
            )}
            {renderDialog()}
        </App>
    );
};

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        blockMargin: { marginRight: 40 },
        flex: { flex: 1 },
        buttons: { display: 'flex', justifyContent: 'flex-end' },
        center: {
            display: 'flex',
            justifyContent: 'center',
            margin: 8,
        },
    }),
);

const ReserverAddPageWithTranslation = withGlobalStyles(
    withTranslation(['reserver', 'reservation', 'booking', 'common'])(ReserverAddPage),
);

const mapStateToProps = (state) => ({
    favorites: riderSelectors.favorites(state),
    dispatchGroups: driverSelectors.sortedDispatchGroup(state),
    poi: bookingSelectors.poi(state),
    poiStatus: bookingSelectors.poiStatus(state),
    bookings: bookingSelectors.bookings(state),
    etaWithGroups: bookingSelectors.etaWithGroups(state),
    availableGroups: bookingSelectors.availableGroups(state),
    priceConfirmation: bookingSelectors.priceConfirmation(state),
    foundRider: riderSelectors.foundRider(state),
    saveReservationError: errorSelectors.saveReservationError(state),
    getBookingOrCancelError: errorSelectors.getBookingOrCancelError(state),
    getCreatePriceConfirmationError: errorSelectors.getCreatePriceConfirmationError(state),
    getConfirmPriceConfirmationError: errorSelectors.getConfirmPriceConfirmationError(state),
    isLoadingOrders: pendingSelectors.isLoadingOrders(state),
});

const mapDispatchToProps = {
    createReservation: reservationActions.createReservation,
    getBooking: bookingActions.getBooking,
    cancelBooking: bookingActions.cancelBooking,
    createPriceConfirmation: bookingActions.createPriceConfirmation,
    confirmPriceConfirmation: bookingActions.confirmPriceConfirmation,
    clearPriceConfirmation: bookingActions.clearPriceConfirmation,
    clearReserver: bookingActions.clearReserver,
    clearPickUp: bookingActions.clearPickUp,
    getAvailableGroups: bookingActions.getAvailableGroups,
    getEtaWithGroups: bookingActions.getEtaWithGroups,
    getRiderFavorite: riderActions.getRiderFavorite,
    getDispatchGroups: driverActions.getDispatchGroups,
    getPoi: bookingActions.getPoi,
    checkFlight: bookingActions.checkFlight,
    clearFlight: bookingActions.clearFlight,
    clearAllErrors: errorActions.clearAllErrors,
};

export default connect(mapStateToProps, mapDispatchToProps)(ReserverAddPageWithTranslation);
